<template>
  <div id="app">
    <loading v-if="load" :fullscrean="true" text="Por favor aguarde"/>
    <status-regional v-else-if="error"/>
    <div v-else>
      <router-view/>
    </div>

    <div class="modal-update" v-if="updateAvailable">
      <div>
        <p class="mb-2 mb-3">Uma nova versão está disponível.</p>
        <button class="btn btn-primary" @click="refreshApp()">Atualizar agora</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "./components/Loading";
  import StatusRegional from "@/components/StatusRegional";

  export default {
    components: {StatusRegional, Loading},
    data() {
      return {
        load: true,
        dados: {},
        user: {},
        error: false,
        updateAvailable: false,
        systemThemeMedia: null,
        isRefreshingApp: false
      }
    },

    methods: {
      getDados(id_regional) {
        if (!id_regional) {
          this.load = false;
          sessionStorage.setItem('redirect', window.location.pathname);

          if (this.$route.name !== 'Home') {
            this.$router.push('/');
          }

          return;
        }

        const url = 'app/dados/' + id_regional;

        this.$http.get(url)
          .then(response => {
            if (response.data) {
              this.dados = response.data;
              this.$store.commit('setDadosApp', this.dados);
              localStorage.setItem(url, JSON.stringify(this.dados))

            } else {
              this.$store.commit('setRegionalId', null);

              if (this.$route.name !== 'Home') {
                this.$router.push('/');
              }
            }

            this.load = false;

          }, res => {
            const data = localStorage.getItem(url);
            console.log(res)

            if (data) {
              this.dados = JSON.parse(data);
              this.$store.commit('setDadosApp', this.dados);

            } else if (!res.status) {
              this.$router.push('/offline');

            } else {
              this.error = true;
            }

            this.load = false;
          });
      },

      getUser() {
        let id_regional = this.$route.query.regional;

        if (this.$route.name === 'Lista' && !id_regional) {
          id_regional = '1';
        }

        let user = this.$helpers.parseJSONObject(localStorage.getItem("userData")) || {};
        this.user = {
          nome_membro: user.nome_membro || '',
          id_membro: user.id_membro || null,
          token: user.token || this.$helpers.ID(),
          id_regional: user.id_regional || id_regional || null,
          id_setor: user.id_setor || '',
          id_cidade: user.id_cidade || ''
        };

        this.$store.commit('setDataUser', this.user);
        let confirmacoes = this.$helpers.parseJSONObject(localStorage.getItem('confirmacoes')) || null;

        if (confirmacoes) {
          const now = new Date().getTime();
          confirmacoes = confirmacoes.filter(c => c.timestamp > now);
          localStorage.setItem('confirmacoes', JSON.stringify(confirmacoes));
          this.$store.commit('setNotificacoes', confirmacoes);
        }

        if (!['App', 'CadastroRRM', 'Termos', 'Privacidade'].includes(this.$route.name)) {
          this.getDados(this.user.id_regional);

        } else {
          this.load = false;
        }
      },

      getSystemTheme() {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 1 : 2;
      },

      applyTheme(themePreference = this.$store.state.theme) {
        const resolvedTheme = themePreference === 0 ? this.getSystemTheme() : themePreference;
        const isDarkMode = resolvedTheme === 1;

        document.body.classList.toggle('dark-mode', isDarkMode);
        this.$store.commit('setTheme', themePreference);
        this.$store.commit('setResolvedTheme', resolvedTheme);
      },

      setTheme() {
        const storedTheme = localStorage.getItem('theme');
        const themePreference = storedTheme ? parseInt(storedTheme, 10) : 0;
        this.applyTheme(Number.isNaN(themePreference) ? 0 : themePreference);
      },

      handleSystemThemeChange() {
        if (this.$store.state.theme === 0) {
          this.applyTheme(0);
        }
      },

      setupThemeListener() {
        if (!window.matchMedia) {
          return;
        }

        this.systemThemeMedia = window.matchMedia('(prefers-color-scheme: dark)');

        if (this.systemThemeMedia.addEventListener) {
          this.systemThemeMedia.addEventListener('change', this.handleSystemThemeChange);
        } else if (this.systemThemeMedia.addListener) {
          this.systemThemeMedia.addListener(this.handleSystemThemeChange);
        }
      },

      refreshApp () {
        this.load = true;
        this.updateAvailable = false;

        if (!navigator.serviceWorker) {
          window.location.reload();
          return;
        }

        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration?.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            return;
          }

          window.location.reload();
        });
      },

      handleServiceWorkerUpdated() {
        this.updateAvailable = true;
      },

      handleServiceWorkerControllerChange() {
        if (this.isRefreshingApp) {
          return;
        }

        this.isRefreshingApp = true;
        window.location.reload();
      }
    },

    mounted() {
      this.setTheme();
      this.setupThemeListener();
      this.getUser();

      document.addEventListener('swUpdated', this.handleServiceWorkerUpdated);
      navigator.serviceWorker?.addEventListener('controllerchange', this.handleServiceWorkerControllerChange);
      window.addEventListener('theme-preference-updated', this.setTheme);
    },

    beforeDestroy() {
      if (this.systemThemeMedia) {
        if (this.systemThemeMedia.removeEventListener) {
          this.systemThemeMedia.removeEventListener('change', this.handleSystemThemeChange);
        } else if (this.systemThemeMedia.removeListener) {
          this.systemThemeMedia.removeListener(this.handleSystemThemeChange);
        }
      }

      document.removeEventListener('swUpdated', this.handleServiceWorkerUpdated);
      navigator.serviceWorker?.removeEventListener('controllerchange', this.handleServiceWorkerControllerChange);
      window.removeEventListener('theme-preference-updated', this.setTheme);
    }
  }
</script>

<style scoped>
.modal-update {
  position: fixed;
  z-index: 9999;
  bottom: 0;
  width: 100%;
  background: var(--bg-theme);
  color: var(--text-theme);
  padding: 32px 15px;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
}

.dark-mode .modal-update {
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.6); /* sombra mais intensa e difusa */
}
</style>
